import styled from "styled-components"

/** Reference palette (dark stat card) */
export const STAT_CARD_BG = "#0a0a0a"
export const STAT_CARD_BORDER = "#262626"
export const STAT_CARD_ICON_BOX_BG = "#1E1E1E"
export const STAT_CARD_DIVIDER = "#262626"
export const STAT_CARD_MUTED = "#71717a"
export const STAT_CARD_TITLE_COLOR = "#ffffff"
export const STAT_CARD_DEFAULT_ACCENT = "#50E3C2"

export const Card = styled.article`
  box-sizing: border-box;
  position: relative;
  width: 100%;
  padding: 24px;
  border-radius: 20px;
  border: 1px solid ${STAT_CARD_BORDER};
  background: ${STAT_CARD_BG};
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const IconBox = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: ${STAT_CARD_ICON_BOX_BG};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;  
  svg {
    width: 22px;
    height: 22px;
  }
`

/** Filled circle for action stimulus color; sits inside IconBox (same slot as leading icon). */
export const StimulusColorCircle = styled.div`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  flex-shrink: 0;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.15);
`

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`

export const StatCardTitle = styled.h2`
  margin: 0;
  min-width: 0;
  max-width: 100%;
  font-family: "Inter", Arial, sans-serif;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.2;
  color: ${STAT_CARD_TITLE_COLOR};
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  word-break: break-word;
`

export const StatCardDescription = styled.p`
  margin: 0;
  font-family: "Inter", Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.35;
  color: ${STAT_CARD_MUTED};
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  word-break: break-word;
`

export const StatsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 12px 24px;
  width: 100%;
`

export const StatItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
`

export const StatIconWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${STAT_CARD_MUTED};

  svg {
    width: 18px;
    height: 18px;
  }
`

export const StatText = styled.span`
  display: inline-flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 4px;
  min-width: 0;
  font-family: "Inter", Arial, sans-serif;
  font-size: 15px;
  line-height: 1.35;
`

export const StatValue = styled.span`
  font-weight: 700;
  color: ${STAT_CARD_TITLE_COLOR};
`

export const StatLabel = styled.span`
  font-weight: 400;
  color: ${STAT_CARD_MUTED};
`

export const FooterBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 0;
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: ${STAT_CARD_DIVIDER};
  flex-shrink: 0;
`

export const Footer = styled.div`
  margin: 0;
  font-family: "Inter", Arial, sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.35;
  color: ${STAT_CARD_MUTED};
`
export const WrapperDeleteButton = styled.div`
  position: absolute;
  top: 10px;
  right: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`